import React from 'react';
import * as PropTypes from 'prop-types';
import clsx from 'clsx';

import { makeStyles } from '@mui/styles';
import grey from '@mui/material/colors/grey';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';

import {
  formatStopAddress,
  formatDisplayNumber,
} from '../../../../models/stop';
import palette from '../../../styles/palette';
import { STOP, ADDRESS, POSTCODE } from '../../../../constants/strings.js';

export const useTableStyles = makeStyles(({ typography }) => ({
  cellText: {
    color: palette.typography.white.solid,
    fontSize: typography.pxToRem(14),
  },
  header: {
    color: palette.typography.white.solid,
    fontWeight: '500',
    fontSize: typography.pxToRem(12),
  },
  headerRow: {
    backgroundColor: grey['200'],
  },
  headerCell: {
    fontWeight: 500,
    fontSize: typography.pxToRem(12),
    lineHeight: typography.pxToRem(14),
    textTransform: 'capitalize',
    color: 'black',
    boxSizing: 'border-box',
    padding: `${typography.pxToRem(13)} ${typography.pxToRem(10)}`,
  },
  bodyCell: {
    fontWeight: 'normal',
    fontSize: typography.pxToRem(12),
    lineHeight: typography.pxToRem(14),
    boxSizing: 'border-box',
    padding: `${typography.pxToRem(4)} ${typography.pxToRem(10)}`,
  },
  stopCell: {
    width: typography.pxToRem(45),
  },
  postcodeCell: {
    width: typography.pxToRem(100),
  },
}));

export function StopMoveToTable({ routeStops }) {
  const tableStyles = useTableStyles();

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow className={tableStyles.headerRow}>
            <TableCell
              className={clsx(tableStyles.headerCell, tableStyles.stopCell)}
            >
              {STOP}
            </TableCell>
            <TableCell className={tableStyles.headerCell}>{ADDRESS}</TableCell>
            <TableCell
              className={clsx(tableStyles.headerCell, tableStyles.postcodeCell)}
            >
              {POSTCODE}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {routeStops.map((stop, index) => (
            <TableRow
              key={index}
              className={tableStyles.bodyRow}
              data-testid={`tr_${index}`}
            >
              <TableCell
                className={clsx(tableStyles.bodyCell, tableStyles.stopCell)}
                data-testid="td_displayNumber"
              >
                {formatDisplayNumber(stop.displayNumber)}
              </TableCell>
              <TableCell
                className={tableStyles.bodyCell}
                data-testid="td_address"
              >
                {formatStopAddress(stop)}
              </TableCell>
              <TableCell
                className={clsx(tableStyles.bodyCell, tableStyles.postcodeCell)}
                data-testid="td_postcode"
              >
                {stop.stopAddress?.postcode}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

StopMoveToTable.propTypes = { routeStops: PropTypes.array.isRequired };
